import React from 'react'
import Figure from './Figure'
import SyntaxHighlighter from 'react-syntax-highlighter';
import {Link} from 'gatsby'

const serializers = {
  types: {
    authorReference: ({node}) => <span>{node.author.name}</span>,
    mainImage: Figure,
    code: ({node}) => {
      const {code, language} = node
      if (!code) { return null }
      return <SyntaxHighlighter language={language || 'text'}>{code}</SyntaxHighlighter>
    },
  },
  marks: {
    internalLink: ({mark, children}) => {
      const href = `/blog/${mark.reference.slug.current}`
      return <Link to={href}>{children}</Link>
    },
    link: ({mark, children}) => {
      // Read https://css-tricks.com/use-target_blank/
      const { blank, href } = mark
      return blank ?
        <a href={href} target="_blank" rel="noopener">{children}</a>
        : <Link to={href}>{children}</Link>
    }
  }
}

export default serializers
